import React from 'react';

function VehicleMobileTabs({
  activeTab,
  setActiveTab,
  tabContent,
  themeColor,
}) {
  return (
    <div className="div-flex-column rg-10 dashboard-card padding-bottom-10">
      <div className="div-flex-row border padding-top-8 border-radius-4">
        {tabContent.map((tabObj, index) => (
          <div
            role="button"
            tabIndex={0}
            key={tabObj?.title}
            onClick={() => setActiveTab(index)}
            className={
              activeTab === index
                ? `div-flex-row cg-20 tab-common py-1 px-3 div-flex-center ${tabObj?.borderColor} border-width-md  div-flex-center`
                : 'div-flex-row cg-20 tab-common py-1 px-3 div-flex-center'
            }
          >
            <span className={`text-sm text-semi-bold ${tabObj?.textColor}`}>
              {tabObj?.title}
            </span>
            <span className={`text-sm text-semi-bold ${tabObj?.textColor}`}>
              {tabObj?.count}
            </span>
          </div>
        ))}
      </div>

      <div className={` theme-scrollable-container-${themeColor}`}>
        {tabContent[activeTab].content}
      </div>
    </div>
  );
}

export default VehicleMobileTabs;
